import './formats.scss';

export default class Formats extends HTMLElement {
  constructor() {
    super();

    // HTML for counter-element
    this.counterHTML = `<a
      class="f-button f-button--choices f-formats__item f-formats__item--counter"
      href="${this.getAttribute('more-url') || '#'}"
      data-automation-id="mini-product-card-format-tile-+n"
      data-track-click="list_clic_format"
    ></a>`;

    const parser = new DOMParser();
    const parsedDocument = parser.parseFromString(this.counterHTML, 'text/html');
    this.counter = parsedDocument.body.firstChild;

    this.oldCounter = null;
    this.classList.add('--active');
    this.maxItems = 3;

    new ResizeObserver(() => {
      this.init();
    }).observe(this);
  }

  init() {
    this.resetPreviousState();

    // Get index of last format visible
    this.index = this.getVisibleIndex();
    const counterHidden = this.children.length - this.index - 1;

    // Skip counter render if all formats are visible
    if (this.index === -1 || counterHidden <= 0) {
      return;
    }

    // Update counter text, title and aria-hidden attributes
    this.setCounterContent(counterHidden);
    this.setCounterTitle(this.index);
    this.setAriaAttributes(this.index);

    // Insert counter-element before first format hidden
    this.insertCounterAfter(this.index);

    // Move counter to display it at the end of visible formats
    if (this.counter.offsetLeft === 0) {
      const isCounterOnlyDisplayed = this.index === 0;
      this.setCounterContent(counterHidden + 1, !isCounterOnlyDisplayed);
      this.moveCounterToStart();
    }

    // Set old values
    this.storePreviousState(this.index);
  }

  resetPreviousState() {
    // Reset aria-hidden and remove counter-element
    if (this.oldCounter !== null) {
      for (const element of Array.from(this.children).slice(this.oldIndex)) {
        element.removeAttribute('aria-hidden');
      }
      this.oldCounter.remove();
      this.oldCounter = null;
    }
  }

  getVisibleIndex() {
    const index = Array.from(this.children)
      .slice(1)
      .findIndex((el) => el.offsetLeft === 0);

    return index >= this.maxItems || index === -1 ? this.maxItems - 1 : index;
  }

  setCounterContent(counterHidden, withSrOnly = true) {
    const srOnlyClass = withSrOnly ? ' class="f-srOnly"' : '';
    this.counter.innerHTML = `+${counterHidden}<span${srOnlyClass}> format${counterHidden > 1 ? 's' : ''}</span>`;
  }

  setCounterTitle(index) {
    this.counter.setAttribute(
      'title',
      Array.from(this.children)
        .slice(index + 1)
        .map((el) => el.innerText)
        .join(', ')
    );
  }

  setAriaAttributes(index) {
    for (const element of Array.from(this.children).slice(index + 1)) {
      element.setAttribute('aria-hidden', 'true');
    }
  }

  insertCounterAfter(index) {
    this.insertBefore(this.counter, this.children[index].nextSibling);
  }

  moveCounterToStart() {
    this.insertBefore(this.counter, this.children[0]);
  }

  storePreviousState(index) {
    this.oldCounter = this.counter;
    this.oldIndex = index;
  }
}

customElements.get('f-formats') || customElements.define('f-formats', Formats);
